var _classCallCheck = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/createClass");

var TokenAuthentication =
/*#__PURE__*/
function () {
  "use strict";

  function TokenAuthentication() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TokenAuthentication);

    this.token = options.token;
    this.scheme = options.scheme || 'Bearer';
  }

  _createClass(TokenAuthentication, [{
    key: "authenticate",
    value: function authenticate(options) {
      options.headers['Authorization'] = this.scheme + ' ' + this.token;
      return options;
    }
  }]);

  return TokenAuthentication;
}();

module.exports = {
  TokenAuthentication: TokenAuthentication
};